import { useRouter as useNextRouter } from 'next/router';

export const useRouter = () => {
  const router = useNextRouter();
  const pathSegments = router.asPath.split('/').filter((segment) => segment !== '');

  return {
    ...router,
    pathSegments,
  };
};